<template>
  <div
    :is-loading="isLoading"
  >
    <b-row>
      <b-col>
        <b-card
          class="mb-0"
          no-body
        >
          <b-card-body class="p-5 text-center">
            <div
              class="h1 m-0"
              data-test="impressions"
            >
              {{ toLocaleString(getImpressions) }}
            </div>
            <div class="text-muted">
              IMPRESSIONS
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card
          class="mb-0"
          no-body
        >
          <b-card-body class="p-5 text-center">
            <div
              class="h1 m-0"
              data-test="clicks"
            >
              {{ toLocaleString(getClicks) }}
            </div>
            <div class="text-muted">
              CLICKS
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card
          class="mb-0"
          no-body
        >
          <b-card-body class="p-5 text-center">
            <div
              class="h1 m-0"
              data-test="ctr"
            >
              {{ toLocaleString(parseFloat(getCTR), true) }} <small v-if="getCTR!=='-'">%</small>
            </div>
            <div class="text-muted">
              CTR
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col v-if="getScrollsDisplayed">
        <b-card
          class="mb-0"
          no-body
        >
          <b-card-body class="p-5 text-center">
            <div
              class="h1 m-0"
              data-test="scrolls"
            >
              {{ toLocaleString(getScrolls) }}
            </div>
            <div class="text-muted">
              SCROLLS
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col v-if="getScrollsDisplayed">
        <b-card
          class="mb-0"
          no-body
        >
          <b-card-body class="p-5 text-center">
            <div
              class="h1 m-0"
              data-test="str"
            >
              {{ toLocaleString(parseFloat(getSTR), true) }} <small v-if="getSTR!=='-'">%</small>
            </div>
            <div class="text-muted">
              STR
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card
          class="mb-0"
          no-body
        >
          <b-card-body class="p-5 text-center">
            <div
              class="h1 m-0"
              data-test="cost"
            >
              <span v-html="formattedMoneyAmount(parseFloat(getSpend))" />
            </div>
            <div class="text-muted">
              COST
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import * as reportingTypes from '@/modules/reporting/store/types';
import currenciesMixin from '@/core/mixins/currencies';
import numbersHelper from '@/core/mixins/numbersHelper';


export default {
  name: 'CampaignOverviewStats',
  mixins: [
    currenciesMixin,
    numbersHelper,
  ],
  data() {
    return {
      isLoading: false,
      deliveryList: [],
    };
  },
  computed: {
    ...mapState('campaigns', [
      'currencies',
      'order',
    ]),
    hasData() {
      return (this.deliveryList.length !== 0);
    },
    getScrollsDisplayed() {
      return this.deliveryList.some((delivery) => delivery.scrolls != null);
    },
    getImpressions() {
      return this.getEventsAmount('impressions');
    },
    getClicks() {
      return this.getEventsAmount('clicks');
    },
    getScrolls() {
      return this.getEventsAmount('scrolls');
    },
    getScrollableImpressions() {
      return this.getEventsAmount('scrollableImpressions');
    },
    getSpend() {
      return this.getEventsAmount('cost');
    },
    getCTR() {
      return this.getEventRate(this.getClicks, this.getImpressions);
    },
    getSTR() {
      return this.getEventRate(this.getScrolls, this.getScrollableImpressions);
    },
  },
  methods: {
    ...mapActions('reporting', [
      reportingTypes.FETCH_CAMPAIGN_DELIVERY_STATS,
    ]),
    fetchDeliveryData() {
      const { advertiserId, campaignId } = this.$route.params;
      const payload = {
        advertiserId,
        campaignId,
      };
      return this.FETCH_CAMPAIGN_DELIVERY_STATS(payload)
        .then((res) => {
          this.deliveryList = res.dailyStats;
        });
    },
    getEventsAmount(name) {
      if (this.deliveryList.length === 0) return '-';
      const { deliveryList } = this;
      return Object.keys(deliveryList)
        .map((key) => deliveryList[key][name])
        .filter((eventsAmount) => eventsAmount)
        .reduce((amount1, amount2) => amount1 + amount2, 0);
    },
    getEventRate(eventsAmount, impressionsAmount) {
      if (this.deliveryList.length === 0 || !eventsAmount || !impressionsAmount) return '-';
      return (eventsAmount) / (impressionsAmount) * 100;
    },
    formattedMoneyAmount(budget) {
      return this.getFormattedMoneyAmountByOrder(budget.toFixed(2), this.order, true);
    },
  },
  created() {
    this.isLoading = true;
    try {
      this.fetchDeliveryData();
    } catch (err) {
      this.isLoading = false;
      this.$router.back();
    }
  },
};
</script>
